import { Component, OnInit, Injector } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalBaseComponent } from '../modal-base-component';

@Component({
  selector: 'app-create-new-group-modal',
  templateUrl: './create-new-group-modal.component.html',
  styleUrls: ['./create-new-group-modal.component.css']
})
export class CreateNewGroupModalComponent extends ModalBaseComponent{

  constructor(private inject: Injector, private _bsModalRef: BsModalRef) { 
    super(inject);
  }

  public closeModal(): void {
    this._bsModalRef.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/create-new-group/create-new-group-modal.component.ts